import * as React from 'react';
import { useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Box from "@material-ui/core/Box";
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import {
    PermIdentity,
    LocationOnOutlined,
    BusinessCenterOutlined,
    Email,
    Print,
    EditOutlined
} from "@material-ui/icons";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useEffect } from "react";
import { format } from "date-fns";
import { enums } from "../../enums/enums";
import { IUsuario } from "../../entities/catalogos/IUsuario";
import { IconButton, Paper } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import { saveMercancias } from "../../redux/actions/mercanciaActions";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { setRecoleccionDestino, setRecoleccionOrigen } from "../../redux/actions/recoleccionActions";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { Mercancia } from "../../entities/solicitudes/Mercancia";
import RegistroUsuario from "../datosPersonales/RegistroUsuario";
import TableContainer from "@material-ui/core/TableContainer";
import useCommonApi from '../../api/useCommonApi';
import { ServicioAdicional } from '../../entities/catalogos/ServicioAdicional';
import Checkbox from "@material-ui/core/Checkbox";
import { ICliente } from '../../entities/catalogos/ICliente';
import Map from '../map/Map';
import LoadingDialog from '../controls/LoadingDialog';
import swal from 'sweetalert2'
import { useHistory } from "react-router-dom";
import { ISolicitudServicioDto } from '../../entities/solicitudes/ISolicitudServicioDto';
import { IRecoleccion } from '../../redux/types/recoleccionActionTypes';
import { useSnackbar } from 'notistack';
import EnviarCorreoDialog from '../controls/EnviarCorreoDialog';
import { IHelp } from "../help/Help";
import { b64toBlob } from "../../blocks/utility";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



const useStyles = makeStyles(() =>
    createStyles({
        root: {
            width: '100%',
            borderCollapse: 'collapse',
            '& td': {
                paddingLeft: "1em"
            },
            '& td:nth-child(odd)': {
                backgroundColor: "#F8F8F8",
                borderLeft: "3px solid #066336",
                paddingRight: "1em"
            },
            '& tr:last-child td': {
                paddingBottom: "1em"
            }
        },

        tableSummary: {
            width: '100%',
            '& td': {
                paddingLeft: "0"
            },
            '& td.price': {
                textAlign: "right"
            }
        },
        total: {
            color: 'white',
            fontWeight: 'bold'
        },
        mensajePrecio: {
            color: 'white',
        },
        icon: {
            width: "30px",
            height: "30px",
            minWidth: "30px",
            borderRadius: "15px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "right",
        },
        mainTitle: {
            color: "#19754e",
            fontSize: "18px",
            fontWeight: "bold"
        },
        title: {
            color: "#19754e",
            fontSize: "10px",
            fontWeight: "bold",
            marginTop: "2em",
            marginBottom: "0.2em",
            '& td': {
                paddingTop: "1em",
                paddingBottom: "0.2em"
            }
        },
        link: {
            color: "#0094ff",
            fontSize: "12px",
            fontWeight: 500,
            cursor: "pointer"
        },
        information: {
            color: "#212121",
            fontSize: "14px",
            fontWeight: 500
        },
        additional: {
            color: " rgba(49,49,49,0.87)",
            fontSize: "12px"
        },
        facturador: {
            color: "#19754e",
            fontSize: "10px",
            fontWeight: "bold",
            marginTop: "2em",
            marginBottom: "0.2em",
            '& td': {
                paddingTop: "2em",
                paddingBottom: "0.2em"
            },
        },
        seccionTitulo: {
            color: "#338462"
        },
        noborder: {
            borderLeft: "none !important",
            paddingRight: "none !important",
            backgroundColor: "#Fff !important",
        },
        infoCliente: {
            fontSize: "12px"
        },
    }),
);

interface OwnProps {
    cotizacionId: number
    siguienteSeccion: (estatusId: number, cotizacionCopia: Solicitud) => void
    datosRemitente?: any
    datosDestinatario?: any

}

interface StateProps {
    solicitud: Solicitud
    usuario: IUsuario
    mercancias: Mercancia[]
    solicitudCopia: Solicitud
    serviciosAdicionales: ServicioAdicional[]
    cliente: ICliente
    ayuda: IHelp
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    saveMercancias: typeof saveMercancias
}

type Props = StateProps & DispatchProps & OwnProps;

let recoleccionConversion = {
    0: "",
    [enums.tipoRecoleccion.ocurre]: traducirLabel(288),//"Sucursal",
    [enums.tipoRecoleccion.comercial]: traducirLabel(44),//"Comercio",
    [enums.tipoRecoleccion.residencial]: traducirLabel(103),//"Domicilio",
};
const apiSource = useCommonApi();
const ResumenConfirmacion = (props: Props) => {
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();
    const [formaEnvio, setFormaEnvio] = useState("");
    const [entrega, setEntrega] = useState("");
    const [fechaRad, setFechaRad] = useState("");
    const [fechaEad, setFechaEad] = useState("");
    const [registrarUsuario, setRegistrarUsuario] = useState(false);
    const [showLoading, setLoading] = useState(false);
    const [aceptaTerminos, setAceptaTerminos] = useState(false);
    const history = useHistory();
    const [distribuidorRemitente, setDistribuidorRemitente] = useState({ id: 0, nombre: "", direccion: "", clienteDistribuidorId: 0, colonia: {}, codigoPostal: "", paisId: 0, estadoId: 0, ciudadId: 0, latitude: 0, longitude: 0 });
    const [contactoRemitente, setContactoRemitente] = useState({ id: 0, nombre: "", departamento: "", puesto: "", telefono: "", correo: "" });
    const [distribuidorDestinatario, setDistribuidorDestinatario] = useState({ id: 0, nombre: "", direccion: "", clienteDistribuidorId: 0, colonia: {}, codigoPostal: "", paisId: 0, estadoId: 0, ciudadId: 0, latitude: 0, longitude: 0 });
    const [contactoDestinatario, setContactoDestinatario] = useState({ id: 0, nombre: "", departamento: "", puesto: "", telefono: "", correo: "" });
    const [showEnviarCorreo, setShowEnviarCorreo] = useState(false);

    useEffect(() => {
        const tipoRecoleccionOrigenId = props.solicitud.tipoRecoleccionIdOrigen ? props.solicitud.tipoRecoleccionIdOrigen : 0;
        const tipoRecoleccionDestinoId = props.solicitud.tipoRecoleccionIdDestino ? props.solicitud.tipoRecoleccionIdDestino : 0;

        if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.ocurre){
            setFormaEnvio(traducirLabel(255)+` ${traducirLabel(288)}`);
        }
        if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.comercial){
            setFormaEnvio(traducirLabel(255)+` ${traducirLabel(44)}`);
        }
        if(tipoRecoleccionOrigenId===enums.tipoRecoleccion.residencial){
            setFormaEnvio(traducirLabel(255)+` ${traducirLabel(103)}`);
        }
        if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.ocurre){
            setEntrega(traducirLabel(115)+` ${traducirLabel(288)}`);
        }
        if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.comercial){
            setEntrega(traducirLabel(115)+` ${traducirLabel(44)}`);
        }
        if(tipoRecoleccionDestinoId===enums.tipoRecoleccion.residencial){
            setEntrega(traducirLabel(115)+` ${traducirLabel(103)}`);
        }
        
        
        let fechaRad = props.solicitud.fechaRecoleccion ?
            (format(props.solicitud.fechaRecoleccion, 'dd MMM yyyy h:mm a')) :
            (props.solicitud.fechaCitaRad ? format(props.solicitud.fechaCitaRad, 'dd MMM yyyy h:mm a') : "")

        if(localStorage.getItem("idioma")==='en-US'){
            fechaRad = props.solicitud.fechaRecoleccion ?
            (format(props.solicitud.fechaRecoleccion, 'MMM dd yyyy h:mm a')) :
            (props.solicitud.fechaCitaRad ? format(props.solicitud.fechaCitaRad, 'MMM dd yyyy h:mm a') : "")
        }
        setFechaRad(fechaRad);
        setFechaEad(props.solicitud.fechaCitaEad ? format(props.solicitud.fechaCitaEad, 'dd MMM yyyy h:mm a') : "");
        if(localStorage.getItem("idioma")==='en-US'){
            setFechaEad(props.solicitud.fechaCitaEad ? format(props.solicitud.fechaCitaEad, 'MMM dd yyyy h:mm a') : "");
        }
        

        if (props.solicitud.distribuidorRemitente) {
            obtenerCoordenadasDistribuidor(props.cliente.id, props.solicitud.distribuidorRemitente.clienteDistribuidorId).then(response => {
                let remitente = { ...props.solicitud.distribuidorRemitente };
                remitente.latitude = response.latitudVerificada;
                remitente.longitude = response.longitudVerificada;
                setDistribuidorRemitente(remitente);
            });
        }

        if (props.solicitud.distribuidorDestinatario) {
            obtenerCoordenadasDistribuidor(props.cliente.id, props.solicitud.distribuidorDestinatario.clienteDistribuidorId).then(response => {
                let destinatario = { ...props.solicitud.distribuidorDestinatario };
                destinatario.latitude = response.latitudVerificada;
                destinatario.longitude = response.longitudVerificada;
                setDistribuidorDestinatario(destinatario);
            });
        }
        if (props.solicitud.contactoOrigen) {
            setContactoRemitente({
                id: props.solicitud.contactoOrigen.id,
                nombre: props.solicitud.contactoOrigen.nombre,
                departamento: "",
                puesto: "",
                telefono: props.solicitud.contactoOrigen.telefono,
                correo: props.solicitud.contactoOrigen.correo
            });
        }
        if (props.solicitud.contactoDestino) {
            setContactoDestinatario({
                id: props.solicitud.contactoDestino.id,
                nombre: props.solicitud.contactoDestino.nombre,
                departamento: "",
                puesto: "",
                telefono: props.solicitud.contactoDestino.telefono,
                correo: props.solicitud.contactoDestino.correo
            });
        }

        let camposValidos = validaCampos();

        if (!camposValidos) {
            enqueueSnackbar(traducirMessage(97), // "Favor de capturar los datos faltantes en los módulos indicados",
                { variant: "error" });
            return
        }
    }, []);

    const obtenerCoordenadasDistribuidor = async (clienteId, clienteDistribuidorId) => {
        const result = await apiSource.obtenerAsync<any>("cliente-distribuidor-direccion/by-cliente-distribuidor", { clienteId: clienteId, clienteDistribuidorId: clienteDistribuidorId });
        return result;
    }

    const guardarSolicitudReferencias = async (referencias) => {
        const result = await apiSource.postAsync<boolean>("solicitud-cliente-referencia", referencias);
        return result;
    };

    const validaCampos = async () => {
        let mensaje = "";
        if (!props.solicitudCopia.distribuidorRemitente) {
            mensaje = traducirMessage(117); // `Favor de seleccionar el Remitente de la Solicitud.`;
            //enqueueSnackbar(mensaje, {variant: "error"});
            //return;
        }
        if (!props.solicitudCopia.contactoOrigen) {
            mensaje = traducirMessage(113); // 'Favor de seleccionar el Contacto del Remitente.';
            //enqueueSnackbar(mensaje, {variant: "error"});
            //return;
        }
        if (!props.solicitudCopia.distribuidorDestinatario) {
            mensaje = traducirMessage(114); // `Favor de seleccionar el Destinatario de la Solicitud.`;
            //enqueueSnackbar(mensaje, {variant: "error"});
            //return;
        }
        if (!props.solicitudCopia.contactoDestino) {
            mensaje = traducirMessage(112); // 'Favor de seleccionar el Contacto del Destinatario.';
            //enqueueSnackbar(mensaje, {variant: "error"});
            //return;
        }
        if (!props.mercancias.length) {
            mensaje = traducirMessage(155); // 'La Solicitud no cuenta con mercancias seleccionadas.';
            //enqueueSnackbar(mensaje, {variant: "error"});
            //return;
        }
        let referencias = await getReferenciasCliente();
        referencias = referencias.filter(a => a.clienteReferenciaID > 0);
        if (referencias.length > 0 && props.solicitudCopia.clienteReferencias?.length === 0) {
            mensaje = traducirMessage(156); // 'La Solicitud no cuenta con referencias de clientes.';
            //enqueueSnackbar(mensaje, {variant: "error"});
            //return;
        }

        if (!props.solicitudCopia.descripcionMercancia) {
            mensaje = traducirMessage(153); // 'La Solicitud no cuenta con el contenido de mercancía de datos de mercancia';
            //enqueueSnackbar(mensaje, {variant: "error"});
            //return;
        }
        if (!props.solicitudCopia.fechaRecoleccion && !props.solicitudCopia.fechaCitaRad && props.solicitudCopia.tipoRecoleccionIdOrigen !== 3) {
            mensaje = traducirMessage(154); // 'La Solicitud no cuenta con fecha de recolección';
            //enqueueSnackbar(mensaje, {variant: "error"});
            //return;
        }
        return mensaje === "";
    }

    const generarSolicituServicio = async () => {
        if (props.cliente.id === 0) {
            setRegistrarUsuario(true);
            return;
        }
        let camposValidos = await validaCampos();

        if (!camposValidos) {
            enqueueSnackbar(traducirMessage(97), //"Favor de capturar los datos faltantes en los módulos indicados", 
                { variant: "error" });
            return
        }
        if (!aceptaTerminos) {
            swal.fire({
                titleText: traducirMessage(276), //'¡Atención!',
                text: traducirMessage(95), //"Favor de aceptar los términos y condiciones.",
                type: 'warning',
            });
            return;
        }

        setLoading(true);
        convertirSolicitud(props.solicitudCopia.id).then(res => {
            if (res.numGuia != "") {

                let referenciasGuardar: any = [];
                if (props.solicitudCopia.clienteReferencias) {


                    props.solicitudCopia.clienteReferencias.forEach(s => {
                        if (s.valor !== '') {
                            referenciasGuardar.push({
                                ...s,
                                solicitudServicioID: res.solicitudServicioID,
                                auditUsuarioID: 0
                            });
                        }
                    });

                    if (referenciasGuardar.length) {
                        guardarSolicitudReferencias(referenciasGuardar).then(refs => {
                            setLoading(false);
                            swal.fire({
                                titleText: traducirMessage(15), //'¡Gracias por confiar en nosotros!',
                                text: traducirMessage(266).replace('#####', res.numGuia), //"Tu solicitud de servicio " + res.numGuia + " ha sido generada con éxito",
                                type: 'success',
                            });
                        });
                    } else {
                        setLoading(false);
                        swal.fire({
                            titleText: traducirMessage(15), //'¡Gracias por confiar en nosotros!',
                            text: traducirMessage(266).replace('#####', res.numGuia), //"Tu solicitud de servicio " + res.numGuia + " ha sido generada con éxito.",
                            type: 'success',
                        });
                    }
                } else {
                    setLoading(false);
                    swal.fire({
                        titleText: traducirMessage(15), //'¡Gracias por confiar en nosotros!',
                        text: traducirMessage(266).replace('#####', res.numGuia), //"Tu solicitud de servicio " + res.numGuia + " ha sido generada con éxito.",
                        type: 'success',
                    });
                }
            }

            history.push("/");
        }).catch(res => {
            console.log(res);
            setLoading(false);
            swal.fire({
                titleText: traducirMessage(276), // '¡Atención!',
                text: traducirMessage(208), // "Ocurrio un error al generar la solicitud de servicio.",
                type: 'error',
            });
        });
    };

    const getReferenciasCliente = async () => {
        const result = await apiSource.obtenerAsync<any>("cliente-referencia/by-id/" + props.cliente.id);
        return result;
    };

    const aceptaterminos = () => {
        window.open('http://ndocum.almex.com.mx/documentacion/pages/GenerarPDF.aspx?TipoPDF=8');
    }

    const materialesPeligrosos = () => {
        window.open('https://www.almex.com.mx/recursos/articulos-prohibidos/');
    }

    const imprimir = () => {
        setLoading(true);
        imprimirCall().then(response => {
            setLoading(false);

            const blob = b64toBlob(response, 'application/pdf');
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = "Cotizacion-" + props.solicitudCopia.solicitudId + ".pdf";
            link.click();
        }).catch(err => {
            setLoading(false);
            swal.fire({
                titleText: traducirMessage(276), // '¡Atención!',
                text: traducirMessage(212), // "Ocurrio un error al imprimir el formato de la cotización.",
                type: 'error',
            });
        });
    }

    const imprimirCall = async () => {
        const result = await apiSource.postAsync<any>("/cotizacion/pdf-sharp-convert/" + props.solicitudCopia.id);
        return result;
    }

    const enviarCorreo = () => {
        setShowEnviarCorreo(true);
    }

    const confirmarEnviarCorreo = () => {
        swal.fire({
            titleText: traducirMessage(14), //'¡Exitoso!',
            text: traducirMessage(54), // "El correo fue enviado exitosamente.",
            type: 'success',
        });

        setShowEnviarCorreo(false);
    }

    const cerrarEnviarCorreo = () => {
        setShowEnviarCorreo(false);
    }

    const handleTerminos = () => {
        setAceptaTerminos(true);
    }

    const convertirSolicitud = async (cotizacionId) => {
        const result = await apiSource.postAsync<any>("/solicitud-servicio", setSolicitudDto());
        return result;
    }

    const currencyFormat = (num) => {
        if (num != null) {
            return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
        else {
            return '$0';
        }
    }

    const servicioAdicionalGuardado = (nombre: string) => {
        let value = 0;
        if (props.solicitud.serviciosAdicionales?.length) {
            let found = props.solicitud.serviciosAdicionales.filter(t => t.nombre === nombre);
            if (found.length) {
                value = 1;
            }
        }
        return value;
    }

    const setServiciosAdicionales = () => {
        let serviciosAdicionales = [
            {
                id: 0,
                aplicaOrigen: true,
                aplicaDestino: true,
                concepto: { conceptoId: 0, nombreConcepto: '' },
                cantidad: 0,
                cantidadOrigen: 0,
                cantidadDestino: 0,
                costo: 0
            }
        ];
        if (props.solicitudCopia.serviciosAdicionales?.length) {
            serviciosAdicionales = [];
            props.solicitudCopia?.serviciosAdicionales.forEach(s => {
                let found = serviciosAdicionales?.filter(t => t.id === s.id);
                if (found && !found.length) {
                    serviciosAdicionales.push({
                        id: s.id,
                        concepto: s.concepto != undefined ? s.concepto : { conceptoId: s.id, nombreConcepto: s.nombre },
                        aplicaOrigen: s.aplicaOrigen,
                        aplicaDestino: s.aplicaDestino,
                        cantidadOrigen: s.cantidadOrigen != null ? s.cantidadOrigen : 0,
                        cantidadDestino: s.cantidadDestino != null ? s.cantidadDestino : 0,
                        cantidad: s.cantidad ? s.cantidad : 0,
                        costo: s.costo ? s.costo : 0,
                    });
                }
            });
        }
        return serviciosAdicionales;
    };

    const setMercancias = (solicitudId) => {
        if (props.mercancias?.length) {
            let mercanciasList: any = [];
            props.mercancias.forEach(s => {
                mercanciasList.push({
                    solicitudID: solicitudId,
                    solicitudMercanciaID: s.id,
                    cantidad: s.cantidad ? s.cantidad : 0,
                    //  embalaje: s.embalaje,
                    embalajeID: s.embalajeId ? s.embalajeId : 0,
                    largo: s.largo ? s.largo : 0,
                    ancho: s.ancho ? s.ancho : 0,
                    alto: s.alto ? s.alto : 0,
                    peso: s.peso ? s.peso : 0,
                    volumen: s.volumen ? s.volumen : 0,
                    esNoEstibable: s.esEstibable ? 1 : 0,
                    convenioID: 0,
                    tarifarioID: 0,
                    noTarima: 0,
                    auditUsuarioID: 0,
                    auditPCMod: "",
                    densidad: 0,
                    pesoFacturado: 0,
                    servicioID: 0,
                    altoReal: s.altoReal ? s.altoReal : 0,
                })

            });
            return mercanciasList;
        }

    }

    const setSolicitudDto = (): ISolicitudServicioDto => {
        const archivosAdjuntosAdd = props.solicitud.archivosAdjuntos ? props.solicitud.archivosAdjuntos : [];
        const archivosAdjuntos: any = [];
        for (const archivo of archivosAdjuntosAdd) {
            archivosAdjuntos.push({ tipo: archivo.tipo, nombreArchivo: archivo.nombre, base64: archivo.file64 });
        }

        return {
            solicitudServicioID: 0,
            empresaID: 0,
            cotizacionID: props.solicitud.cotizacionId,
            estatusSolicitudID: 1,
            clienteID: props.solicitud.facturador && props.solicitud.facturador?.id > 0 ? props.solicitud.facturador.id : props.cliente.id,
            remitenteID: props.solicitud.distribuidorRemitente?.id,
            destinatarioID: props.solicitud.distribuidorDestinatario?.id,
            sucursalClienteID: 0,
            sucursalRemitenteID: props?.solicitud?.sucursalOrigen?.id ? props?.solicitud?.sucursalOrigen?.id : 0,
            sucursalDestinatarioID: props?.solicitud?.sucursalDestino?.id ? props?.solicitud?.sucursalDestino?.id : 0,
            areaServicioClienteID: 0,
            areaServicioRemitenteID: props?.solicitud?.areaServicioOrigenId ? props?.solicitud?.areaServicioOrigenId : 0,
            areaServicioDestinatarioID: props?.solicitud?.areaServicioDestinoId ? props?.solicitud?.areaServicioDestinoId : 0,
            direccionCliente: "",
            direccionRemitente: props.solicitud.distribuidorRemitente.direccion,
            direccionDestinatario: props.solicitud.distribuidorDestinatario.direccion,
            tipoServicioID: props.solicitudCopia.tipoServicio?.id ? props.solicitudCopia.tipoServicio?.id : 0,
            tipoEnvioID: props.solicitudCopia.tipoEnvio?.id ? props.solicitudCopia.tipoEnvio?.id : 0,
            proyectoID: props.solicitudCopia.proyecto?.id ? props.solicitudCopia.proyecto?.id : 0,
            esFlete: 0,
            esEad: props?.solicitud?.esRad ? 1 : 0,
            fechaCitaEAD: props?.solicitud?.fechaCitaEad ? props?.solicitud?.fechaCitaEad : undefined,
            fechaCitaRAD: props?.solicitud?.fechaCitaRad ? props?.solicitud?.fechaCitaRad : undefined,
            esRad: props?.solicitud?.esEad ? 1 : 0,
            esSeguroMercancia: props.solicitudCopia?.esSeguroMercancia ? 1 : 0,
            esSeguroBasico: props.solicitudCopia?.esSeguroBasico ? 1 : 0,
            esCobrarEnDestino: servicioAdicionalGuardado("COBRO EN DESTINO") == 0 ? 0 : 1,
            valorMercancia: props?.solicitud.valorMercancia ? props?.solicitud.valorMercancia : 0,
            unidadMercanciaID: props.solicitudCopia?.unidadMedidaLongitudId ? props.solicitudCopia?.unidadMedidaLongitudId : 0,
            unidadMedidaMercanciaID: props.solicitudCopia?.unidadMedidaPesoId ? props.solicitudCopia?.unidadMedidaPesoId : 0,
            claseID: 0,
            //clase: '',
            descripcionMercancia: props.solicitudCopia.descripcionMercancia ? props.solicitudCopia.descripcionMercancia : "",
            fechaEnvioEstimado: undefined,
            fechaAlta: undefined,
            totalCantidadMercancia: 0,
            totalPesoMercancia: 0,
            totalVolumenMercancia: 0,
            totalPesoVolumen: 0,
            totalPesoFacturado: 0,
            convenioID: 0,
            fechaCancelacion: undefined,
            usuarioCancelaId: 0,
            monedaID: 0,
            descuento: 0,
            tipoCambio: 0,
            ivaID: 0,
            retencionID: 0,
            descuentoMonto: 0,
            iva: props?.solicitud.iva ? props?.solicitud.iva : 0,
            retencion: props?.solicitud.retencion ? props?.solicitud.retencion : 0,
            subTotal: props?.solicitud.subtotal ? props?.solicitud.subtotal : 0,
            total: props?.solicitud.total ? props?.solicitud.total : 0,
            retornoDocumentos: servicioAdicionalGuardado("RETORNO DOCUMENTOS"),
            observaciones: props.solicitudCopia.observaciones ? props.solicitudCopia.observaciones : "",
            numGuiaRetorno: "",
            auditFecha: undefined,
            auditUsuarioID: 0,
            auditPCMod: "",
            nombre_Recibe: "",
            fecha_Recibe: undefined,
            estatusRetornoDocumentoId: 0,
            cruce: 0,
            entarimar: 0,
            cartaInstruccion: "",
            cartaInstruccionNombre: "",
            numGuia: props.solicitud?.numGuia ? props.solicitud?.numGuia : '',
            remitenteContacto: contactoRemitente.nombre,
            destinatarioContacto: contactoDestinatario.nombre,
            esPendienteDefinirRAD: 0,
            esPendienteDefinirEAD: 0,
            telefonoAdicionalRemitente: "",
            recoleccionId: 0,
            esEADCita: 0,
            esRADCita: 0,
            esOcurreOrigen: props.solicitud?.ocurreOrigen ? props.solicitud?.ocurreOrigen : 0,
            esOcurreDestino: props.solicitud?.ocurreDestino ? props.solicitud?.ocurreDestino : 0,
            fechaRecoleccion: undefined,
            correo: props.usuario?.email,
            esMasiva: 0,
            tipoMasivaID: 0,
            fechaRADfin: undefined,
            remitenteContactoId: contactoRemitente.id,
            destinatarioContactoId: contactoDestinatario.id,
            grupoClienteId: props.cliente.id,
            grupoProyectoId: props.solicitud?.proyecto?.id ? props.solicitud?.proyecto?.id : 0,
            esCapturaReferencia: false,
            esPlatinum: false,
            distribuidorLogisticoId: 0,
            tipoFleteID: 0,
            tipoImpuestoID: 0,
            tipoImpuestoRetencionID: 0,
            esResidencialOrigen: !!props.solicitud?.esResidencialOrigen,
            esResidencialDestino: !!props.solicitud?.esResidencialDestino,
            markupMonto: 0,
            markupPorcentaje: 0,
            tipoMarkupId: 0,
            solicitudConceptos: setServiciosAdicionales(),
            solicitudMercancias: setMercancias(props.solicitud.id),
            solicitudArchivos: archivosAdjuntos,
            EsRadCitaFueraHorario: props.solicitud?.EsRadCitaFueraHorario,
            EsEadCitaFueraHorario: props.solicitud?.EsEadCitaFueraHorario,
            idioma: localStorage.getItem("idioma") === null ? "es-MX" : localStorage.getItem("idioma")
        };
    };

    const cambiarSeccion = (seccionId) => {
        const nuevaCotizacion = new Solicitud({ ...props.solicitud, seccionId: seccionId });
        props.setSolicitud(nuevaCotizacion);
        props.setSolicitudCopia(nuevaCotizacion);
    };

    return (<>
        {!registrarUsuario &&
            <>
                <Paper>
                    <Box display="flex" px={3} pt={2} alignItems="center" flexWrap="wrap">
                        <Box className={classes.mainTitle} flexGrow={1}>
                            {/* SOLICITUD SERVICIO {props.solicitud.numGuia} */}
                            {traducirMessage(284)} {props.solicitud.numGuia}
                        </Box>

                        {props.solicitud.id > 0 &&
                            <Box m={1}>
                                <Button color="primary" onClick={imprimir}>
                                    <Print /> {/*Imprimir*/ traducirLabel(164)}
                                </Button>
                                <Button color="primary" onClick={enviarCorreo}>
                                    <Email /> {/*Enviar por Email*/ traducirLabel(121)}
                                </Button>
                            </Box>
                        }
                    </Box>

                    <Box p={3} pt={2}>
                        <Divider />

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8}>
                                <Box display="flex" flexDirection="column">
                                    <Box display="flex" mb={1} mt={3}>
                                        <PermIdentity />
                                        <Box ml={1}>
                                            <b className={classes.seccionTitulo}>
                                                {/* Datos Cliente */
                                                    traducirLabel(67)}
                                            </b>
                                        </Box>
                                    </Box>

                                    <Box ml={4}>

                                        <table >
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: "400px" }} className={classes.infoCliente} >
                                                        <Box><strong>{!props.solicitudCopia.nombreTarifaAlmex ? props.cliente.nombre : props.solicitudCopia.nombreTarifaAlmex}</strong></Box>
                                                        <Box>{props.solicitudCopia.empresaTarifaAlmex}</Box>
                                                        <Box>{!props.solicitudCopia.telefonoTarifaAlmex ? props.cliente.telefono : props.solicitudCopia.telefonoTarifaAlmex}</Box>
                                                        <Box>{props.solicitud.correo}</Box>
                                                    </td>
                                                    <td>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Box>
                                </Box>

                                <Box display="flex" flexDirection="column" mt={3}>
                                    <Box display="flex" mb={1}>
                                        <LocationOnOutlined />
                                        <Box ml={1}><b className={classes.seccionTitulo}>
                                            {/* Origen y Destino */
                                                traducirLabel(223)}
                                        </b></Box>
                                    </Box>

                                    <table className={classes.root}>
                                        <tbody>
                                            <tr>
                                                <td className={classes.noborder} >

                                                    <table style={{ width: "100%", backgroundColor: "#fff" }}>
                                                        <tbody>

                                                            <tr style={{ fontSize: "12px", color: "rgba(0,0,0,0.87)", fontWeight: 600, border: "none !Important", backgroundColor: "#fff !Important", padding: "0 !Important" }}>
                                                                <td className={classes.noborder} style={{ width: "35%", wordBreak: "break-all" }}>
                                                                    <p><strong>
                                                                        {/* REMITENTE */
                                                                            traducirLabel(262)}
                                                                    </strong></p>

                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        <strong>{distribuidorRemitente.clienteDistribuidorId > 0 ? distribuidorRemitente.clienteDistribuidorId : ''} {distribuidorRemitente.nombre}</strong>
                                                                    </p>
                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        {distribuidorRemitente.direccion}
                                                                    </p>

                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        <strong>{props.solicitud.contactoOrigen?.nombre}</strong>
                                                                    </p>
                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        {props.solicitud.contactoOrigen?.telefono}
                                                                    </p>
                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        {props.solicitud.contactoOrigen?.correo}
                                                                    </p>
                                                                </td>
                                                                <td className={classes.noborder}>
                                                                    <p style={{ width: "150px", textAlign: "right" }}>
                                                                        <IconButton size="small" onClick={() => cambiarSeccion(enums.estatusSolicitud.origenDestino)}>
                                                                            <EditOutlined style={{ fontSize: 25 }} />
                                                                        </IconButton>
                                                                    </p>
                                                                    <div style={{ width: "150px", height: "150px" }}>
                                                                        {props.solicitud.distribuidorRemitente && props.solicitud.distribuidorRemitente.id > 0 && props.solicitud.distribuidorRemitente.latitude > 0 &&
                                                                            <Map setDireccion={props.solicitud.coloniaOrigen?.direccion}
                                                                                setCalle={props.solicitud.coloniaOrigen?.direccion}
                                                                                setCalleNumero={0}
                                                                                setEstado={props.solicitud.coloniaOrigen?.estado?.nombre}
                                                                                setZip={props.solicitud.coloniaOrigen?.nombre}
                                                                                height='150px'
                                                                                paisId={props.solicitud.coloniaOrigen?.pais.id}
                                                                                setLatitude={Number(props.solicitud.distribuidorRemitente?.latitude)} setLongitude={Number(props.solicitud.distribuidorRemitente?.longitude)} zoom={15}
                                                                                center={{ lat: Number(props.solicitud.distribuidorRemitente?.latitude), lng: Number(props.solicitud.distribuidorRemitente?.longitude) }} />
                                                                        }
                                                                        {distribuidorRemitente?.latitude === 0 && distribuidorRemitente?.longitude === 0 &&
                                                                            <Map setDireccion={props.solicitud.coloniaOrigen?.direccion}
                                                                                setCalle={props.solicitud.coloniaOrigen?.direccion}
                                                                                setCalleNumero={0}
                                                                                setEstado={props.solicitud.coloniaOrigen?.estado?.nombre}
                                                                                setZip={props.solicitud.coloniaOrigen?.nombre}
                                                                                height='150px'
                                                                                paisId={props.solicitud.coloniaOrigen?.pais.id}
                                                                                setLatitude={0} setLongitude={0} zoom={15}
                                                                                center={{ lat: 0, lng: 0 }} />
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td className={classes.noborder} style={{ width: "35%", wordBreak: "break-all" }}>
                                                                    <p><strong>
                                                                        {/* DESTINATARIO */
                                                                            traducirLabel(85)}
                                                                    </strong>

                                                                    </p>
                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        <strong>  {distribuidorDestinatario.clienteDistribuidorId > 0 ? distribuidorDestinatario.clienteDistribuidorId : ''} {distribuidorDestinatario.nombre}</strong>
                                                                    </p>
                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        {distribuidorDestinatario.direccion}
                                                                    </p>
                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        <strong>{props.solicitud.contactoDestino?.nombre}</strong>
                                                                    </p>
                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        {props.solicitud.contactoDestino?.telefono}
                                                                    </p>
                                                                    <p style={{ wordBreak: "break-word" }}>
                                                                        {props.solicitud.contactoDestino?.correo}
                                                                    </p>
                                                                </td>
                                                                <td className={classes.noborder}>
                                                                    <p style={{ width: "150px", textAlign: "right" }}>
                                                                        <IconButton size="small" onClick={() => cambiarSeccion(enums.estatusSolicitud.origenDestino)}
                                                                            disabled={contactoRemitente.id == 0}>
                                                                            <EditOutlined style={{ fontSize: 25 }} />
                                                                        </IconButton>
                                                                    </p>
                                                                    <div style={{ width: "150px", height: "150px" }}>
                                                                        {props.solicitud.distribuidorDestinatario && props.solicitud.distribuidorDestinatario.id > 0 && props.solicitud.distribuidorDestinatario.latitude > 0 &&

                                                                            <Map setDireccion={props.solicitud.coloniaOrigen?.direccion}
                                                                                setCalle={props.solicitud.coloniaOrigen?.direccion}
                                                                                setCalleNumero={0}
                                                                                setEstado={props.solicitud.coloniaOrigen?.estado?.nombre}
                                                                                setZip={props.solicitud.coloniaOrigen?.nombre}
                                                                                height='150px'
                                                                                paisId={props.solicitud.coloniaOrigen?.pais.id}
                                                                                setLatitude={Number(props.solicitud.distribuidorDestinatario?.latitude)} setLongitude={Number(props.solicitud.distribuidorDestinatario?.longitude)} zoom={15}
                                                                                center={{ lat: Number(props.solicitud.distribuidorDestinatario?.latitude), lng: Number(props.solicitud.distribuidorDestinatario?.longitude) }} />

                                                                        }
                                                                        {distribuidorDestinatario?.latitude === 0 && distribuidorDestinatario?.longitude === 0 &&

                                                                            <Map setDireccion={props.solicitud.coloniaOrigen?.direccion}
                                                                                setCalle={props.solicitud.coloniaOrigen?.direccion}
                                                                                setCalleNumero={0}
                                                                                setEstado={props.solicitud.coloniaOrigen?.estado?.nombre}
                                                                                setZip={props.solicitud.coloniaOrigen?.nombre}
                                                                                height='150px'
                                                                                paisId={props.solicitud.coloniaOrigen?.pais.id}
                                                                                setLatitude={0} setLongitude={0} zoom={15}
                                                                                center={{ lat: 0, lng: 0 }} />
                                                                        }
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            <tr style={{ fontSize: "12px", color: "rgba(0,0,0,0.87)", fontWeight: 600 }}>
                                                                <td className={classes.noborder}>


                                                                </td>
                                                                <td className={classes.noborder}>

                                                                    <p>{formaEnvio}</p>
                                                                    <ul style={{ margin: 0, paddingLeft: "1.5em" }}>
                                                                        {fechaRad && <li>{fechaRad}</li>}

                                                                        {localStorage.getItem("idioma") === 'en-US' && props.solicitud.serviciosAdicionales?.map(sa =>
                                                                            sa.seleccionado && sa.aplicaOrigen ?
                                                                                <li key={sa.id}>{sa.etiquetaServicioAdicionalDto?.nombre == null ? sa.nombre : sa.etiquetaServicioAdicionalDto.nombre}</li> : null
                                                                        )
                                                                        }
                                                                        {localStorage.getItem("idioma") !== 'en-US' && props.solicitud.serviciosAdicionales?.map(sa =>
                                                                            sa.seleccionado && sa.aplicaOrigen ?
                                                                                <li key={sa.id}>{sa.nombre}</li> : null
                                                                        )
                                                                        }
                                                                    </ul>
                                                                </td>

                                                                <td className={classes.noborder}>
                                                                </td>

                                                                <td className={classes.noborder}>
                                                                    <p>{entrega}</p>
                                                                    <ul style={{ margin: 0, paddingLeft: "1.5em" }}>
                                                                        {fechaEad && <li>{fechaEad}</li>}

                                                                        {localStorage.getItem("idioma") === 'en-US' && props.solicitud.serviciosAdicionales?.map(sa =>
                                                                            sa.seleccionado && sa.aplicaDestino ?
                                                                                <li key={sa.id}>{sa.etiquetaServicioAdicionalDto?.nombre == null ? sa.nombre : sa.etiquetaServicioAdicionalDto.nombre}</li> : null
                                                                        )
                                                                        }
                                                                        {localStorage.getItem("idioma") !== 'en-US' && props.solicitud.serviciosAdicionales?.map(sa =>
                                                                            sa.seleccionado && sa.aplicaDestino ?
                                                                                <li key={sa.id}>{sa.nombre}</li> : null
                                                                        )
                                                                        }
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Box>

                                <Box display="flex" flexDirection="column" mt={3}>
                                    <Box display="flex" mb={1}>
                                        <BusinessCenterOutlined />
                                        <Box ml={1}><b className={classes.seccionTitulo}>
                                            {/* Detalle de Mercancía */
                                                traducirLabel(88)}
                                        </b></Box>
                                    </Box>

                                    <Box ml={4}>
                                        <TableContainer component={Paper}>
                                            <Table className="table-xs" size="small" aria-label="a dense table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center">
                                                            {/* No. */
                                                                traducirLabel(193)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Cant. */
                                                                traducirLabel(29)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Embalaje */
                                                                traducirLabel(111)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Largo x Ancho x Alto */
                                                                traducirLabel(174)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Volumen */
                                                                traducirLabel(320)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* Peso */
                                                                traducirLabel(229)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {/* No Estibable */
                                                                traducirLabel(190)}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.mercancias.length > 0 && props.mercancias?.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">{index + 1}</TableCell>
                                                            <TableCell align="center"> {row.cantidad}</TableCell>
                                                            {(localStorage.getItem("idioma") === 'en-US') &&
                                                                <TableCell align="center">{row.etiquetaEmbalaje?.nombre !== undefined ? row.etiquetaEmbalaje?.nombre : row.embalaje}</TableCell>
                                                            }
                                                            {(localStorage.getItem("idioma") !== 'en-US') &&
                                                                <TableCell align="center">{row.embalaje?.nombre != undefined ? row.embalaje?.nombre : row.embalaje}</TableCell>
                                                            }
                                                            <TableCell
                                                                align="center">{`${row.largo} x ${row.ancho} x ${row.alto}`}</TableCell>
                                                            <TableCell align="center">{row.volumen?.toFixed(3)}</TableCell>
                                                            <TableCell align="center">{Number.isInteger(row.peso ?? 0) ? row.peso : row.peso?.toFixed(3)}</TableCell>
                                                            <TableCell
                                                                align="center">{row.esEstibable ? 'Si' : 'No'}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>

                                    <Box ml={4}>
                                        <div>
                                            <table>
                                                <tr>
                                                    <td> <Checkbox name="aplicaOrigen" color="primary" size="small" checked={aceptaTerminos}
                                                        onChange={handleTerminos} /></td>
                                                    <td><span className={classes.link} onClick={aceptaterminos}>
                                                        {/* Acepto t&eacute;rminos y condiciones */
                                                            traducirLabel(3)}
                                                    </span></td>
                                                    <td style={{ width: "300px", textAlign: "center" }}>
                                                        <span className={classes.link} onClick={materialesPeligrosos}>
                                                            {/* Materiales Peligrosos */
                                                                traducirLabel(184)}
                                                        </span>
                                                    </td>

                                                </tr>
                                            </table>

                                        </div>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Box style={{ backgroundColor: "#f5f5f5" }}>
                                    <Box p={3}>
                                        {props.cliente.monedaID == 1 &&
                                            <>
                                                <Button variant="contained">MXN</Button>
                                                <Button variant="outlined" disabled={true}>USD</Button>
                                            </>
                                        }
                                        {props.cliente.monedaID != 1 &&
                                            <>
                                                <Button variant="outlined" disabled={true}>MXN</Button>
                                                <Button variant="contained" >USD</Button>
                                            </>
                                        }

                                        <Box className={classes.title}>
                                            {/* ENVÍO */
                                                traducirLabel(122)}
                                        </Box>

                                        <Box className={classes.information}>
                                            {props.solicitud.tipoEnvio?.nombre}
                                        </Box>

                                        <Box className={classes.title}>
                                            {/* SERVICIO */
                                                traducirLabel(276)}
                                        </Box>

                                        <Box className={classes.information}>
                                            {props.solicitud.tipoServicio?.nombre}
                                        </Box>

                                        {props.cliente.esClase == true &&
                                            <>
                                                <Box className={classes.title}>
                                                    {/* Clase */
                                                        traducirLabel(34)}
                                                </Box>

                                                <Box className={classes.information}>
                                                    {props.solicitud.clase}
                                                </Box>
                                            </>
                                        }

                                        <table className={classes.tableSummary} style={{ marginTop: '0.7em' }}>
                                            <tbody>
                                                <tr className={classes.title}>
                                                    <td colSpan={2}>
                                                        {/* PESO FACTURADO */
                                                            traducirLabel(230)}
                                                    </td>
                                                </tr>
                                                <tr className={classes.information}>
                                                    {localStorage.getItem("idioma")!=='en-US' &&
                                                        <td>{props.solicitud.totalPesoMercancia ? props.solicitud.totalPesoMercancia : 0}  {props.solicitud.unidadMedidaPesoId == 1 ? 'kg.' : 'Lib.'} /{props.solicitud.totalPesoVolumen ? props.solicitud.totalPesoVolumen : 0} {props.solicitud.unidadMedidaLongitudId == 3 ? 'Mts3.' : 'Pul'}</td>
                                                    }
                                                    {localStorage.getItem("idioma")==='en-US' &&
                                                        <td>{props.solicitud.totalPesoMercancia ? props.solicitud.totalPesoMercancia : 0}  {props.solicitud.unidadMedidaPesoId == 1 ? 'kg.' : 'Pound.'} /{props.solicitud.totalPesoVolumen ? props.solicitud.totalPesoVolumen : 0} {props.solicitud.unidadMedidaLongitudId == 3 ? 'Mts3.' : 'Inch'}</td>
                                                    }
                                                    <td className="price">{props.solicitud.totalPesoFacturado ? currencyFormat(props.solicitud.totalPesoFacturado) : currencyFormat(0)}
                                                    </td>
                                                </tr>
                                                <tr className={classes.title}>
                                                    <td colSpan={2} style={{ paddingTop: '2em' }}>
                                                        {/* SERVICIOS ADICIONALES */
                                                            traducirLabel(278)}
                                                    </td>
                                                </tr>
                                                {props.solicitud.serviciosAdicionales?.map(sa =>
                                                    <tr className={classes.information}>
                                                        {localStorage.getItem("idioma")!=='en-US' &&
                                                            <td>{sa.concepto ? sa.concepto.nombreConcepto : sa.nombre}</td>
                                                        }
                                                        {localStorage.getItem("idioma")==='en-US' &&
                                                            <td>{sa.concepto ? ((sa.concepto.etiquetaConcepto?.nombreConcepto == null || sa.concepto.etiquetaConcepto?.nombreConcepto === '') ?  sa.concepto.nombreConcepto : sa.concepto.etiquetaConcepto.nombreConcepto) : ((sa.etiquetaServicioAdicionalDto.nombre == null || sa.etiquetaServicioAdicionalDto.nombre === '') ? sa.nombre: sa.etiquetaServicioAdicionalDto.nombre)}</td>
                                                        }
                                                        <td className="price">{currencyFormat(sa.costo ? sa.costo : 0)}</td>
                                                    </tr>
                                                )}

                                                {/* ESTA SECCION ESTARA COMENTADA HASTA QUE SE DEFINAN EL PROCESO DE MARKUP*/
                                                props.solicitudCopia.markupMonto != undefined && props.solicitudCopia.markupMonto > 0 &&
                                                    <>
                                                        <tr className={classes.information}>
                                                            <td>
                                                                {/* MARKUP */
                                                                traducirMessage(181)}
                                                            </td>
                                                            <td className="price">{currencyFormat(props.solicitud.markupMonto)}</td>
                                                        </tr>
                                                    </>
                                                }
                                                <tr className={classes.title}>
                                                    <td colSpan={2} style={{ paddingTop: '2em' }}>
                                                        {/* TIPO DE SEGURO */
                                                        traducirLabel(302)}
                                                    </td>
                                                </tr>
                                                <tr className={classes.information}>
                                                    <td>{props.solicitudCopia.esSeguroBasico ? 'SEGURO BÁSICO' : props.solicitudCopia.esSeguroMercancia ? 'SEGURO DECLARADO' : ''}</td>
                                                    <td className="price">{props.solicitud.esSeguroBasico ? currencyFormat(props.solicitud.costoSeguro) : currencyFormat(Number(props.solicitud.valorMercancia) * .01)}</td>
                                                </tr>
                                                <tr style={{ height: '40px' }}>
                                                    <td colSpan={2}>
                                                        <Divider />
                                                    </td>
                                                </tr>

                                                <tr className={classes.information}
                                                    style={{ height: '35px', verticalAlign: 'bottom' }}>
                                                    <td>
                                                        {/* Subtotal */
                                                        traducirLabel(287)}
                                                    </td>
                                                    <td className="price">{props.solicitud.subtotal ? currencyFormat(props.solicitud.subtotal) : currencyFormat(0)}</td>
                                                </tr>

                                                <tr className={classes.information}>
                                                    <td>
                                                        {/* IVA */
                                                        traducirLabel(166)}
                                                    </td>
                                                    <td className="price">{props.solicitud.iva ? currencyFormat(props.solicitud.iva) : currencyFormat(0)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Box>

                                    <Box style={{ backgroundColor: "#338462" }}>
                                        <Box px={3} py={2}>
                                            <table className={classes.tableSummary}>
                                                <tbody>
                                                    <tr className={classes.total}>
                                                        <td>
                                                            {/* TOTAL */
                                                            traducirLabel(305)}
                                                        </td>
                                                        <td className="price">{props.solicitud.total ? currencyFormat(props.solicitud.total) : currencyFormat(0)}</td>
                                                    </tr>
                                                    <tr style={{ height: '40px', color: 'white' }}>
                                                        <td colSpan={2}>
                                                            <Divider />
                                                        </td>
                                                    </tr>
                                                    <tr className={classes.mensajePrecio}>
                                                        <td>
                                                            {/* * Precios sujetos a medición y pesaje de la mercancía. */
                                                            traducirMessage(8)}
                                                            </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>

                <Box display="flex" justifyContent="flex-end" mt={2} mb={3}>
                    <Box>
                        <Button variant="contained" color="primary" onClick={() => generarSolicituServicio()}>
                            {/* Confirmar Solicitud de Servicio */
                            traducirMessage(49)}
                        </Button>
                    </Box>

                </Box>
            </>
        }

        {registrarUsuario &&
            <RegistroUsuario callback={generarSolicituServicio} />
        }

        {
            showLoading &&
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }

        {showEnviarCorreo &&
            <EnviarCorreoDialog tipo="cotizacion" cerrar={cerrarEnviarCorreo} confirmar={confirmarEnviarCorreo} abierto={showEnviarCorreo} registroId={props.solicitud.id} />
        }

    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    solicitud: state.solicitud,
    usuario: state.usuario,
    mercancias: state.mercancias,
    solicitudCopia: state.solicitudCopia,
    cliente: state.cliente,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    saveMercancias: saveMercancias
};

export default connect(mapStateToProps, mapDispatchToProps)(ResumenConfirmacion);
